/**
 * Created by Ning Jiang on 2021-06-16.
 */

import {WinPresentationController} from "../WinPresentationController";
import {Serial} from "../../Serial";
import {SerialSymbolState} from "../../symbol/SerialSymbolConfig";

export class NoWinSymbolsController extends WinPresentationController {

    constructor() {
        super("NoWinSymbolsController", false);
    }

    protected hasWin():boolean {
        return Serial.model.parsedGameData.betWins.length > 0 || Serial.model.parsedGameData.freespinTriggeredThisSpin;
    }

    protected async createWinAnimation():Promise<void> {
        const promises:Promise<any>[] = [];

        Serial.model.parsedGameData.winPositions.forEach((reelWin, reelId) => {
            reelWin.forEach((win, symId) => {
                if(win) {
                    return;
                }
                if(reelId === 4 && symId === Serial.model.parsedGameData.scatterPositions[4]) {
                    return;
                }
                promises.push(Promise.resolve(Serial.getSymbol(reelId, symId).getStateAnimation(
                    SerialSymbolState.NO_WIN,
                    {duration : 0.1, alpha : 1},
                    {duration : 0.1, alpha : 0}
                )));
            });
        });

        await Promise.all(promises);
    }
}